// extracted by mini-css-extract-plugin
module.exports = {"newAddressFormWrapper":"style_newAddressFormWrapper___yNAE"};